import '../../assets/stylesheet.css';

export * from './withTheme';
export * from './overrides';
export * from './palette';
export * from './themes';
export * from './typography';


export const applyGlobalStyles = () => {
  // call this method to prevent this module from being tree-shaken
  console.log('Global styles applied ui-v2');
};
